module.exports = __webpack_public_path__ + "img/其他调查-文字信息@2x.f1facd1c.jpg";